import React, { FC } from 'react'

import { PractitionerSettings } from '../../../../../../lib/practitioner-settings/types'
import CommissionsProgram from '../CommissionsProgram'
import * as Styled from './styled'

export interface CommissionsProgramSectionProps {
  settings: PractitionerSettings
}

const CommissionsProgramSection: FC<CommissionsProgramSectionProps> = ({ settings }) => {
  const isEligibleForCommissions = !settings?.practitioner?.ineligibleForCommissions

  return (
    <div>
      <h3 className="small-h3">Commissions</h3>
      <Styled.Description>
        Earn affiliate commissions by simply recommending our products to your patients. Open your
        own Virtual Dispensary and earn up to 50% profit share.
      </Styled.Description>
      <CommissionsProgram settings={settings}>
        <Styled.Label disabled={!isEligibleForCommissions}>Commissions Program</Styled.Label>
      </CommissionsProgram>
      {!isEligibleForCommissions && (
        <Styled.IneligibleText>Your account is ineligible for commissions.</Styled.IneligibleText>
      )}
    </div>
  )
}

export default CommissionsProgramSection
